import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { trackEvent } from '../../utils/metaPixel';
interface CTAButtonProps {
  children: React.ReactNode;
  href?: string;
  onClick?: () => void;
  className?: string;
  fullWidth?: boolean;
}
export function CTAButton({
  children,
  href = 'https://alexhealthmarket.com/cart/42833225121840:1',
  onClick,
  className = '',
  fullWidth = false
}: CTAButtonProps) {
  const handleClick = (e: React.MouseEvent) => {
    trackEvent('AddToCart', {
      content_name: 'Plan 7D Control',
      content_type: 'product',
      value: 8.99,
      currency: 'USD'
    });
    onClick?.();
  };
  return <motion.a href={href} target="_blank" rel="noopener noreferrer" whileHover={{
    scale: 1.05
  }} whileTap={{
    scale: 0.95
  }} onClick={handleClick} className={`
        relative overflow-hidden group cursor-pointer
        bg-[#10B981] hover:bg-[#0ea5e9] text-white 
        font-extrabold text-lg md:text-xl 
        py-4 px-8 rounded-full 
        shadow-[0_8px_30px_rgb(16,185,129,0.3)]
        transition-colors duration-300
        flex items-center justify-center gap-3
        no-underline
        ${fullWidth ? 'w-full' : ''}
        ${className}
      `} data-id="element-210">
      <span className="relative z-10" data-id="element-211">{children}</span>
      <ArrowRight className="w-6 h-6 relative z-10 group-hover:translate-x-1 transition-transform" data-id="element-212" />

      {/* Shine effect */}
      <div className="absolute inset-0 -translate-x-full group-hover:animate-[shimmer_1.5s_infinite] bg-gradient-to-r from-transparent via-white/20 to-transparent z-0" data-id="element-213" />
    </motion.a>;
}